module.exports = __webpack_public_path__ + "static/img/1.8d76291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/VTS/1.png
// module id = Vpks
// module chunks = 1